export default "__VITE_ASSET__CWA9qdLK__"